import React from 'react';
import { css } from '@emotion/react';
import { StyledPillButtonAsLink } from '../primitives/styled-pill-button';
import Typography from '../primitives/typography';
import { AVERAGE_RATE_THRESHOLD } from '../../constants/constants';
import RowSet from '../primitives/grid/row-set';
import { StyledButtonAsLink } from '../primitives/styled-button';
import PhoneNumber from '../molecules/phone-number';
import Divider from '../primitives/divider';
import { RatingSummary } from '../atoms/RatingSummary';
import formatPhoneLink from '../utils/format-phone-link';
import { FranchiseData } from '../../sourcing/source-nodes/sources/franchises';

// Centralized styles
const styles = {
    container: css({
        width: '100%',
        padding: '12px 0',
    }),
    rowSet: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    }),
    pillButton: css({
        marginTop: '10px',
    }),
    divider: css({
        marginTop: '12px',
    }),
};

const NearestItem = (data: FranchiseData): JSX.Element => {
    const {
        name,
        mainPhone,
        permalink,
        reviewCount,
        averageRating,
    } = data;

    return (
        <div css={styles.container}>
            <RowSet
                breakpoints={{ dt: { between: 12 } }}
                css={styles.rowSet}
            >
                <div>
                    <Typography fontSize="2xl" fontWeight="medium">
                        {name}
                    </Typography>
                    {(!!averageRating && reviewCount !== 0 && averageRating >= AVERAGE_RATE_THRESHOLD) && (
                        <RatingSummary count={reviewCount} rating={averageRating} />
                    )}
                </div>
                <PhoneNumber
                    as={StyledButtonAsLink}
                    to={`tel:${formatPhoneLink(mainPhone)}`}
                >
                    {formatPhoneLink(mainPhone)}
                </PhoneNumber>
                <StyledPillButtonAsLink
                    css={styles.pillButton}
                    to={permalink}
                >
                    Find Out More ›
                </StyledPillButtonAsLink>
            </RowSet>
            <Divider css={styles.divider} />
        </div>
    );
};

export default NearestItem;
